import React, { useState } from "react";
import { FaSpinner, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { BsExclamationLg } from "react-icons/bs";

import { FaRegSquareCheck } from "react-icons/fa6";
import {
  declineProduct,
  fetchPendingApprovals,
} from "../../../redux/slices/producersSlice";

export default function DeclineProducerProduct({ id, name }) {
  const [showModal, setShowModal] = useState(false);
  const [reason, setMessage] = useState("");
  const status = useSelector((state) => state.declineProductStatus?.status);
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    console.log("id", id, reason);
    try {
      const res = await dispatch(declineProduct({ id, reason }));
      await dispatch(fetchPendingApprovals());
      toast.success(res.payload.message);
    } catch (error) {
      toast.error("Failed to approve tradefair");
      console.error(error);
    }
    setShowModal(false);
  };

  return (
    <>
      <div className=" flex items-center">
        <button
          type="button"
          onClick={() => setShowModal(true)}
          className="font-medium"
        >
          <FaRegSquareCheck className="text-red-600 text-lg" />
        </button>
      </div>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-5xl">
              <div className="border-0 rounded-lg p-6 shadow-lg relative flex flex-col bg-white outline-none focus:outline-none">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center"
                >
                  <FaTimes className="text-gray-300 text-xl" />
                  <span className="sr-only">Close modal</span>
                </button>
                <div className=" text-center mb-4">
                  <h1 className="text-2xl text-gray-800 mb-4 text-center font-medium">
                    Approve Producer Product
                  </h1>
                  <p>Do you want to Approve this Producer Product</p>
                </div>
                <div className="flex justify-center items-center m-2">
                  <BsExclamationLg className="text-gray-500 text-3xl font-bold" />
                </div>
                <div className="flex items-center px-8 py-4 gap-6">
                  <div className="flex flex-col gap-4">
                    <div className="flex flex-col gap-2 justify-center items-center">
                      <div className="flex flex-row gap-2 justify-center items-center">
                        <h1 className="text-[14px] text-left text-gray-400 ">
                          name :
                        </h1>
                        <div className="">
                          <p className=" text-base font-bold">{name}</p>
                        </div>
                      </div>
                      <div className="relative p-6 flex flex-col gap-2">
                        <label
                          htmlFor="reason"
                          className="text-base text-center"
                        >
                          Reason
                        </label>
                        <textarea
                          className="w-full p-2 border border-gray-300 rounded"
                          placeholder="Enter your reason"
                          rows={4}
                          cols={30}
                          value={reason}
                          onChange={(e) => setMessage(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="flex mt-2 gap-4 justify-center">
                      <button
                        onClick={() => setShowModal(false)}
                        className="text-sm text-gray-500 font-semibold bg-gray-100 py-2 px-4 rounded-md"
                      >
                        Cancel
                      </button>
                      <button
                        className="flex gap-1 rounded-md items-center bg-red-600 text-white py-2 px-4"
                        disabled={status === "loading"}
                        onClick={handleSubmit}
                      >
                        {status === "loading" ? (
                          <>
                            <FaSpinner className="animate-spin" />
                            <p className="text-sm font-semibold whitespace-nowrap">
                              Declining ...
                            </p>
                          </>
                        ) : (
                          <>
                            <FaTimes className="w-4 h-4" />
                            <p className="text-sm font-semibold whitespace-nowrap">
                              Decline
                            </p>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}
